import mixpanel from 'mixpanel-browser';
import { MIXPANEL_PROJECT_ID, MIXPANEL_ENABLED } from '../../../constants/app-constants';
import { AnalyticsClient } from '../analytics-client';

export class MixpanelAnalyticsClient implements AnalyticsClient {
  constructor() {
    if (MIXPANEL_ENABLED) {
      mixpanel.init(MIXPANEL_PROJECT_ID);
    }
  }

  trackEvent(eventName: string, properties: Record<string, any> = {}): void {
    if (MIXPANEL_ENABLED) {
      try {
        mixpanel.track(eventName, properties);
      } catch (e) {
        mixpanel.track('ERROR: Failed to track event of name ' + eventName + ', Error: ' + e);
      }
    }
  }

  identifyUser(userId?: string): void {
    if (MIXPANEL_ENABLED) {
      try {
        mixpanel.identify(userId);
      } catch (e) {
        mixpanel.track('ERROR: Failed to identify user with ID ' + userId + ', Error: ' + e);
      }
    }
  }

  setUserProperties(properties: Record<string, any>): void {
    if (MIXPANEL_ENABLED) {
      mixpanel.people.set(properties);
    }
  }
}
